// eslint-disable-next-line import/prefer-default-export
export const QualificationRule = Object.freeze({
    None: 0,
    MatchQualification: 1,
    MatchPrimaryJobAndJobTransferSet: 2,
    MatchPrimaryJobOnly: 3,
});
